import { render, staticRenderFns } from "./ModalAtalhos.vue?vue&type=template&id=6b454e02&scoped=true&"
import script from "./ModalAtalhos.vue?vue&type=script&lang=js&"
export * from "./ModalAtalhos.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtalhos.vue?vue&type=style&index=0&id=6b454e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b454e02",
  null
  
)

export default component.exports